<template>
  <AuthCard>
    <div class="text-center" data-test="signout-status">
      <p>Signing out…</p>
    </div>
  </AuthCard>
</template>

<script setup>
import {inject, onMounted} from 'vue';
import * as Sentry from '@sentry/browser';
import AuthCard from './components/AuthCard.vue';

const api = inject('api'),
      urls = inject('urls');

onMounted(async () => {
  try {
    await api.delete(urls.signoutApiUrl);
  } catch (err) {
    // allauth.headless returns 401 once the session is dropped — that's success.
    const status = err?.response?.status;
    if (status !== 401) {
      Sentry.captureException(err);
    }
  }
  window.location.href = urls.signinUrl;
});
</script>
